import no_wifi from "../assets/images/no-wifi.png";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonImg,
  IonButton,
} from "@ionic/react";
import createHistory from "history/createBrowserHistory";
import { useHistory } from "react-router";
import { ActionType } from "../models/Enums";
import { networkConnectionStatus } from "../data/atoms";
import { useRecoilState } from "recoil";
interface Props {
  setShouldShowNetWorkPopup: Function;
}
// const NetworkError: React.FC<Props> = ({ setShowNetworkError }) => {
const NetworkError: React.FC<Props> = ({ setShouldShowNetWorkPopup }) => {
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(networkConnectionStatus);
  // const history = createHistory();
  let history = useHistory();
  function handleClick() {
    ////;
    // console.log("Click .....")
    // localStorage.clear();
    // window.location.href = window.location.origin + "/login";
    setShouldShowNetWorkPopup(false);
    // history.goBack();
    // history.push("/login")
    // history.push("/login")
    //route on basis of action type
    //  history.push("/code");
  }
  return (
    <IonContent placeholder={undefined}>
      {/* Start of Network Error Modal  */}
      <div className="overall-center-modal">
        <div className="generic-modal-main-wrap">
          <div className="icon-sec text-center">
            <div>
              <svg
                width="186"
                height="129"
                viewBox="0 0 186 129"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M92.9747 0C85.1426 0 78.9517 6.65156 79.4988 14.4549L83.7892 74.3478C84.1348 79.1853 88.1372 82.9286 92.9747 82.9286C97.8122 82.9286 101.815 79.1853 102.16 74.3766L106.451 14.4837C106.998 6.65156 100.807 0 92.9747 0ZM92.9747 129C97.8623 129 102.55 127.058 106.006 123.602C109.462 120.146 111.403 115.459 111.403 110.571C111.403 105.684 109.462 100.996 106.006 97.5405C102.55 94.0844 97.8623 92.1429 92.9747 92.1429C88.0872 92.1429 83.3998 94.0844 79.9437 97.5405C76.4877 100.996 74.5461 105.684 74.5461 110.571C74.5461 115.459 76.4877 120.146 79.9437 123.602C83.3998 127.058 88.0872 129 92.9747 129Z"
                  fill="#802392"
                />
                <path
                  opacity="0.4"
                  d="M73.74 1.43895C71.2637 5.38382 69.9679 10.1061 70.3135 15.1452L70.7166 20.7026C49.8981 24.9642 31.2103 35.0711 16.4387 49.2381C12.753 52.751 6.93645 52.6358 3.4235 48.9789C-0.0894415 45.322 0.0257369 39.4767 3.68266 35.9637C22.4568 17.8807 46.7306 5.4702 73.74 1.43895ZM112.238 1.43895C139.248 5.4702 163.493 17.8807 182.296 35.9349C185.982 39.4479 186.097 45.2932 182.555 48.9501C179.013 52.607 173.197 52.751 169.54 49.2093C154.768 35.0423 136.08 24.9354 115.262 20.6738L115.665 15.1164C116.011 10.1061 114.715 5.35502 112.238 1.41016V1.43895ZM72.7034 48.5758L74.0568 67.3211C65.188 70.0278 57.1255 74.6349 50.33 80.6242C46.5003 83.9932 40.6838 83.6189 37.3148 79.818C33.9458 76.0171 34.3202 70.1718 38.121 66.8028C47.8824 58.1932 59.6882 51.8296 72.7034 48.5758ZM111.922 67.3211L113.246 48.5758C126.261 51.8584 138.067 58.1932 147.829 66.8028C151.63 70.1718 152.004 75.9883 148.635 79.818C145.266 83.6477 139.449 83.9932 135.62 80.6242C128.824 74.6349 120.762 70.0566 111.893 67.3211H111.922Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>

          <div className="generic-modal-text">
            <h1>No Connection</h1>
            <p>
              No Wifi connection. Choose to continue with data or wait until
              connection is reestablished.
            </p>
          </div>

          <div className="generic-modal-btn-wrap two-btns">
            {/* <ul>
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    setShouldShowNetWorkPopup();
                  }}
                >
                  Cancel
                </IonButton>
              </li>

              <li>
                <IonButton className="generic-btn" placeholder={undefined}>
                  Use Data
                </IonButton>
              </li>
            </ul> */}
            <IonButton className="generic-btn" placeholder={undefined}>
                  Use Data
                </IonButton>
          </div>
        </div>
      </div>
      {/* End of Network Error Modal Modal */}
    </IonContent>
  );
};
export default NetworkError;
